import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import ExportCsvDialog from '../components/ExportCsvDialog';
import Logger from '../services/Logger';
import store from '../store';

/** Show Export to CSV dialog */
export default function showExportCsvDialog(props) {
  const $wrapper = document.createElement('div');
  $wrapper.classList.add('wrapperDialog');
  $wrapper.classList.add('exportDialogWrapper');
  document.body.appendChild($wrapper);
  const root = createRoot($wrapper);

  Logger.log('User', 'ExportToCsvModalShown', {
    assets_number: props.assetIds.length,
    initiation_location: props.initiationLocation || 'unknown',
  });

  function destroy() {
    root.unmount($wrapper);
    document.body.removeChild($wrapper);
  }
  root.render(<Provider store={store}><ExportCsvDialog destroy={destroy} {...props} /></Provider>);
}
